angular
    .module('annexaApp')
    .component('annexaSelectThirdsDocuments', {
        templateUrl: './components/common/annexa-select-thirds-documents/annexa-select-thirds-documents.html',
        controller: ['$filter', '$rootScope', 'NotificationFactory', 'ThirdFactory', 'GlobalDataFactory', 'CommonService', 'Language', '$state', function($filter, $rootScope, NotificationFactory, ThirdFactory, GlobalDataFactory, CommonService, Language, $state) {
            var vm = this;
			vm.selectedAllThirds = false;
            vm.languageColumn = Language.getActiveColumn();
			
            if(!vm.titleDocuments) {
                vm.titleDocuments = 'global.literals.documents'
            }
            if(!vm.title) {
                vm.title = 'global.literals.thirds';
            }

            if(!$rootScope.app.configuration.notification_representatives.value) {
                vm.thirds = $linq(vm.thirds).where("x => x.interested").toArray();
            }
            if($rootScope.app.configuration.notification_identification_reference.active){
            	vm.notification_identification_reference = $rootScope.app.configuration.notification_identification_reference;
            }
            
            vm.selectNotificationType = function(item, third) {
            	if(item && item.identificationDestinataryType && item.identificationDestinataryPattern &&
            			third && third.third && third.third.identificationDocument) {
            		var patterns = item.identificationDestinataryPattern.split(",");
            		third.canReciveNotificationType = true;
            		switch (item.identificationDestinataryType) {
            			case "START":
            				third.canReciveNotificationType = false;
            				_.forEach(patterns, function (pattern) {
            					if(third.third.identificationDocument.startsWith(pattern.replace(/\s+/g, ''))) {
            						third.canReciveNotificationType = true;
            					}
            				});
            				break;
            			case "NOT_START":
            				_.forEach(patterns, function (pattern) {
            					if(third.third.identificationDocument.startsWith(pattern.replace(/\s+/g, ''))) {
            						third.canReciveNotificationType = false;
            					}
            				});
            				break;
            			case "FINISH":
            				third.canReciveNotificationType = false;
            				_.forEach(patterns, function (pattern) {
            					if(third.third.identificationDocument.endsWith(pattern.replace(/\s+/g, ''))) {
            						third.canReciveNotificationType = true;
            					}
            				});
            				break;
            			case "NOT_FINISH":
            				_.forEach(patterns, function (pattern) {
            					if(third.third.identificationDocument.endsWith(pattern.replace(/\s+/g, ''))) {
            						third.canReciveNotificationType = false;
            					}
            				});
            				break;
            			case "CONTAINS":
            				third.canReciveNotificationType = false;
            				_.forEach(patterns, function (pattern) {
            					if(third.third.identificationDocument.includes(pattern.replace(/\s+/g, ''))) {
            						third.canReciveNotificationType = true;
            					}
            				});
            				break;
            			case "NOT_CONTAINS":
            				_.forEach(patterns, function (pattern) {
            					if(third.third.identificationDocument.includes(pattern.replace(/\s+/g, ''))) {
            						third.canReciveNotificationType = false;
            					}
            				});
            				break;
            			default:
            				third.canReciveNotificationType = true;
            		}
            	} else {
            		third.canReciveNotificationType = true;
            	}
            }
 			
			_.forEach(vm.thirds, function (value, key) {
				vm.thirds[key].documentsToSelect = [];
            	
				var notificationAddress;
            	var selectedNotificationType;
            	var alertAddressSelected;
            	
            	if(vm.addressIdSelected && vm.addressIdSelected[vm.thirds[key].id]) {
            		notificationAddress = vm.addressIdSelected[vm.thirds[key].id];
            	} else {
            		//Comprobamos si el dossier del tercero es igual al dossier del padre, si es diferente sabemos que se trata de un expediente hijo
            		notificationAddress = NotificationFactory.getNotificationAddress(value.third, ((value.dossier && value.dossier.id && vm.dossier && vm.dossier.id != value.dossier.id)? value.dossier : vm.dossier));
            	}
            	
            	if(vm.notificationTypeSelected && vm.notificationTypeSelected[vm.thirds[key].id]) {
            		selectedNotificationType = vm.notificationTypeSelected[vm.thirds[key].id];
            	}
            	
            	if(vm.alertAddressSelected && vm.alertAddressSelected[vm.thirds[key].id]) {
            		alertAddressSelected = vm.alertAddressSelected[vm.thirds[key].id];
            	}
            	
            	if($state.current.name.startsWith('annexa.reg')){
            		if(value.thirdAddress && isNaN(value.thirdAddress) && !value.thirdAddress.deleted) {
            			notificationAddress = value.thirdAddress;
            		}else if(value.thirdAddress && !isNaN(value.thirdAddress) && value.third && value.third.addresses){
            			notificationAddress = $linq(value.third.addresses).firstOrDefault("x => x.id == "+value.thirdAddress);
            		}
                }
            	
                vm.thirds[key].selected = ((value.selected === true || value.selected === false)?value.selected:false);
                vm.thirds[key].canReciveNotificationType = true;
                vm.thirds[key].label = CommonService.getThirdCompleteName(value.third);
                vm.thirds[key].labelHtml = CommonService.getThirdRelationType(value);
                vm.thirds[key].labelAddress = notificationAddress ? CommonService.getThirdAddress(notificationAddress) : '';
                var otherNotificationTypes = angular.copy($linq(GlobalDataFactory.notificationTypes).where("x => x.addressType == 'OTHER'").toArray());
                var notificationTypesCopy = angular.copy(GlobalDataFactory.notificationTypes);
                //Comprobamos si el dossier del tercero es igual al dossier del padre, si es diferente sabemos que se trata de un expediente hijo
                if($rootScope.app.configuration && $rootScope.app.configuration.create_with_consents && $rootScope.app.configuration.create_with_consents.value == true && ThirdFactory.getThirdAddresWithConsent(value.third, ((value.dossier && value.dossier.id && vm.dossier && vm.dossier.id != value.dossier.id)? value.dossier : vm.dossier))) {
                    vm.thirds[key].addressesOrig = [angular.copy(notificationAddress)];
                    _.forEach(vm.thirds[key].addressesOrig, function (address) {
                        address.selected = true;
                        address.labelAddress = CommonService.getThirdAddress(address);
                        address.notificationTypes = $linq(notificationTypesCopy).where("x => x.addressType == '" + address.addressType + "'").toArray();
                        address.selectedNotificationType = address.notificationTypes.length != 0 ? address.notificationTypes[0] : undefined;
                        if(address.selectedNotificationType) {
                            vm.selectNotificationType(address.selectedNotificationType, vm.thirds[key]);
                        }
                    });
                } else {
                    vm.thirds[key].addressesOrig = angular.copy(vm.thirds[key].third.addresses);
                    _.forEach(vm.thirds[key].addressesOrig, function (address) {
                    	if (notificationAddress) {
                    		if(address.id == notificationAddress.id){
                    			address.selected = true;
                    		}else{
                    			address.selected = false;
                    		}
                    	}else if(address.default){
                            address.selected = true;
                        }else{
                            address.selected = false;
                        }
                        address.labelAddress = CommonService.getThirdAddress(address);
                        address.notificationTypes = $linq(notificationTypesCopy).where("x => x.addressType == '" + address.addressType + "'").toArray();
                        address.selectedNotificationType = address.notificationTypes.length != 0 ? address.notificationTypes[0] : undefined;
                        
                        if(selectedNotificationType){
                        	selectedNotificationType = $linq(notificationTypesCopy).firstOrDefault(undefined, "x => x.id == '" + selectedNotificationType.id + "'");
                        }
                        
                        if(selectedNotificationType){
                        	vm.selectNotificationType(selectedNotificationType, vm.thirds[key]);
                        	address.selectedNotificationType = selectedNotificationType
                        }else if(address.selectedNotificationType) {
                        	vm.selectNotificationType(address.selectedNotificationType, vm.thirds[key]);
                        }
                        
                    });
                }
                var identReference = true;
                if(otherNotificationTypes != null && otherNotificationTypes.length > 0){
                	if(vm.notification_identification_reference && vm.notification_identification_reference.active){
                		var otherNotificationTypesTemp = [];
                		identReference = false;
                		_.forEach(vm.notification_identification_reference.notification_types, function(types){
                			if($linq(otherNotificationTypes).select("x=>x.code").contains(types.type)){
                				var third_reference_types = $linq(vm.thirds[key].third.identificationReferences).select("x => x.identificationReferenceType.code").toArray();
                				var reference_types = $linq(types.reference_types).intersect(third_reference_types).toArray();
                				if(reference_types.length > 0){
                					identReference = true;
                					otherNotificationTypesTemp = $linq(otherNotificationTypesTemp).union($linq(otherNotificationTypes).where("x=>x.code =='" + types.type +"'").toArray()).toArray();
                				}
                			}
                		});
                		otherNotificationTypes = otherNotificationTypesTemp;
                	}
                	if(identReference){
                		if(!vm.thirds[key].addressesOrig){
                    		vm.thirds[key].addressesOrig = [];
                    	}
                    	var addressOther = {
                    			addressType: "OTHER",
                    			labelAddress:"Altres",
                    			notificationTypes: otherNotificationTypes,
                    			selectedNotificationType: ((otherNotificationTypes.length != 0) ? otherNotificationTypes[0] : undefined),
                    			selected: false
                    	};
                    	
                    	if(!vm.addressIdSelected[vm.thirds[key].id] && selectedNotificationType) {
                    		addressOther.selected = true;
                    		addressOther.selectedNotificationType = selectedNotificationType;
                    		_.forEach(vm.thirds[key].addressesOrig, function (address) {
                    			if(address.selected) address.selected = false;
                    		});
                    	}
                    	
                    	vm.thirds[key].addressesOrig.push(addressOther);
                	}
                }
                if (vm.removeAddressesWithoutSelectedNotificationType && vm.removeAddressesWithoutSelectedNotificationType == true) {
                	//No se muestran los canales cuyo tipo no tiene definido tipo de notificacion.
                	vm.thirds[key].addressesOrig = $linq(vm.thirds[key].addressesOrig).where("x => x.selectedNotificationType != undefined").toArray();
                }
                _.forEach(vm.thirds[key].third.addresses, function (address) {
                	address.labelAddress = CommonService.getThirdAddress(address);
                });
                _.forEach(vm.thirds[key].addressesOrig, function (address) {
                	_.forEach(address.notificationTypes, function (notType) {
                		if(notType.addressTypeAlert) {
                    		var alertAddList = $linq(vm.thirds[key].third.addresses).where("x => x.addressType == '" + notType.addressTypeAlert + "'").toArray();
                    		if(alertAddList && alertAddList.length >= 1) {
                    			notType.alertAddresses = angular.copy(alertAddList);
                    			notType.alertAddresses.unshift({labelAddress: 'Sense avís', id: 0});
                    			notType.selectedAlertAddress = notType.alertAddresses[0];
                    			
                    			if(alertAddressSelected) {
                    				var toSelectAlert = $linq(notType.alertAddresses).firstOrDefault(undefined, "x => x.telematicValue == '" + alertAddressSelected + "'");
                    				if(toSelectAlert) {
                    					notType.selectedAlertAddress = toSelectAlert;
                    				}
                    			}
                    		}
                		}
                	});
                });
                vm.thirds[key].selectedAll = false;
    			vm.thirds[key].documentsToSelect = angular.copy(vm.documents);
                _.forEach(vm.thirds[key].documentsToSelect, function (valueDoc, keyDoc) {
                	vm.thirds[key].documentsToSelect[keyDoc].selected = ((vm.thirds[key].selectedAll)?true:false);
                	
                	if (vm.documentsIdSelected) {
                		var documentSelected = $linq(vm.documentsIdSelected[vm.thirds[key].id]).where("x => x.document.id == " + vm.thirds[key].documentsToSelect[keyDoc].id).toArray();
                		if (documentSelected.length > 0) {
                			vm.thirds[key].documentsToSelect[keyDoc].selected = true;
                		}
                	}
                });
                vm.thirds[key].selectedAll = (($linq(vm.thirds[key].documentsToSelect).count("x => x.selected") == vm.thirds[key].documentsToSelect.length)?true:false);
            });

            vm.selectThird = function ($event, index) {
                var checkbox = $event.target;

                vm.thirds[index].selected = checkbox.checked;
                if(checkbox.checked) {
                	vm.selectNotificationType($linq(vm.thirds[index].addressesOrig).firstOrDefault({selectedNotificationType: undefined}, "x => x.selected == true").selectedNotificationType, vm.thirds[index]);
                }
            };

            vm.selectAddress = function (thirdId, addressId) {
                var third = $linq(vm.thirds).where("x => x.third.id =="+thirdId).toArray();
                if(third && third.length > 0){
                    _.forEach(third, function(value){
                        if(value.addressesOrig){
                            _.forEach(value.addressesOrig, function(value2){
                                if(value2.id == addressId){
                                    value2.selected = true;
                                    if(value2.selectedNotificationType){
                                    	vm.selectNotificationType(value2.selectedNotificationType, value);
                                    }
                                }else{
                                    value2.selected = false;
                                }
                            });
                        }
                    });
                }
            };
			
            vm.selectDocument = function ($event, index, third) {
                var checkbox = $event.target;

                third.documentsToSelect[index].selected = checkbox.checked;
				if(!checkbox.checked){
					third.selectedAll = false;
				}else{
					third.selectedAll = (($linq(third.documentsToSelect).count("x => x.selected") == third.documentsToSelect.length)?true:false);
				}
            }

			vm.selectAll = function(third){
				_.forEach(third.documentsToSelect, function (value, key) {
					third.documentsToSelect[key].selected = ((third.selectedAll)?true:false);
            	});
			}
			vm.selectAllThirds = function(){
				_.forEach(vm.thirds, function (value, key) {
					vm.thirds[key].selected = ((vm.selectedAllThirds)?true:false);
				});
				$rootScope.$broadcast('annexa-select-thirds-documents-selectedThirds', {});
			}
        }],
        bindings: {
            title: '@?',
            thirds: '=',
            dossier: '=?',
            hideAddresses: '=',
            removeAddressesWithoutSelectedNotificationType: '=',
			thirdsEnabled: '=?',
            titleDocuments: '@?',
            documents: '=',
            documentsIdSelected: '=',
            disableSelecctions: '=',
            addressIdSelected: '=',
            notificationTypeSelected: '=',
            alertAddressSelected: '='
        }
    })